export default __webpack_public_path__ + "static/media/logo7.beceb36d.jpg";